import type { CreatorCollaborationPackage } from '@/biz/multiPlatformCollaboration/model';
import type { CreatorAudienceViewV2 } from '@/interface/creatorOrderV2';
import CreatorPackageAudienceData from './CreatorPackageAudienceData';
export type CreatorPackageAudiencePreviewProps = {
  collaborationPackage: CreatorCollaborationPackage;
  includedPlacementIds: string[];
  audienceViews?: CreatorAudienceViewV2[];
  onRefreshAudience?: () => Promise<void>;
  failedAudienceKeys?: ReadonlySet<string>;
  onRetryAudienceAnalysis?: (channelKey: string) => void;
  onValidityChange?: (valid: boolean) => void;
  audienceError?: boolean;
};
/** Only server-provided audience data is displayed. */
export default function CreatorPackageAudiencePreview(
  props: CreatorPackageAudiencePreviewProps
) {
  return <CreatorPackageAudienceData {...props} />;
}
